import { IInputTheme } from '../../models/IInputTheme';
import { colors } from './colors';

export const inputTheme: IInputTheme = {
  withCleanButton: true,
  variants: {
    outline: {
      padding: {
        top: '10px',
        left: '15px',
        right: '7px',
        bottom: '10px',
      },
      border: {
        top: '1px',
        left: '1px',
        right: '1px',
        bottom: '1px',
      },
      borderRadius: '3px',
      color: colors.neutral.gray,
      borderColor: colors.neutral.grayWarm,
      backgroundColor: colors.neutral.white,
    },
    flushed: {
      padding: {
        top: '10px',
        left: '15px',
        right: '7px',
        bottom: '10px',
      },
      border: {
        top: '1px',
        left: '1px',
        right: '1px',
        bottom: '1px',
      },
      borderRadius: '3px',
      color: colors.neutral.gray,
      borderColor: colors.neutral.grayWarm,
      backgroundColor: colors.neutral.white,
    },
    baseline: {
      padding: {
        top: '10px',
        left: '15px',
        right: '7px',
        bottom: '10px',
      },
      border: {
        top: '0',
        left: '0',
        right: '0',
        bottom: '1px',
      },
      borderRadius: '0',
      color: colors.neutral.gray,
      borderColor: colors.neutral.silver,
      backgroundColor: colors.neutral.white,
    },
  },
  state: {
    error: {
      color: colors.transactional.base,
      borderColor: colors.transactional.base,
      fontSize: '14px',
      lineHeight: '16px',
    },
    success: {
      color: colors.neutral.green,
      borderColor: colors.neutral.green,
    },
  },
};
